import { Theme } from '@mui/material'

import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: `0px solid ${theme.palette.custom.grey}`,
    borderRadius: 15,
    position: 'relative',
  },
  chooseContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'start',
    flexDirection: 'row',
    width: '100%',
    height: '2.5rem',
    border: `1px solid ${theme.palette.custom.grey}`,
    borderRadius: 20,
    paddingLeft: SPACES.xxxl,
    paddingRight: SPACES.xxxl,
  },
}))

export default useStyles
